export default __webpack_public_path__ + "static/chair-lg-2ae530991e4ae593d27654379cd763b5.png";